/**
 * Utility functions for BusinessNameSearch component
 */

/**
 * Check if click is outside element
 * @param element - Element to check
 * @param event - Mouse event
 * @returns True if click is outside
 */
export const isClickOutside = (element: HTMLElement | null, event: MouseEvent): boolean => {
  if (!element) return true;
  return !element.contains(event.target as Node);
};

/**
 * Get validation error message
 * @param required - Whether field is required
 * @param hasSelection - Whether a selection has been made
 * @param hasUserTyped - Whether user has typed anything
 * @param validationMessage - Custom validation message
 * @returns Error message or null
 */
export const getValidationError = (
  required: boolean,
  hasSelection: boolean,
  hasUserTyped: boolean,
  validationMessage?: string
): string | null => {
  if (!required) return null;
  if (!hasUserTyped) return null;
  if (!hasSelection) {
    return validationMessage ?? 'Please select a valid Company from the list.';
  }
  return null;
};
